import * as logger from 'loglevel';
import { publish } from '../../pubsub';

export default (fare) => {
  let momentFormattedDeparture = null;
  let momentFormattedReturn = null;
  if (window && window.EM && window.EM.utils && window.EM.utils.PubSub) {
    // eslint-disable-next-line
    const fcRuntime = window.EM.___fcRuntime;
    if (fcRuntime && fcRuntime.vendors && fcRuntime.vendors.moment) {
      const infameMomentPleaseDontImportMeNever = fcRuntime.vendors.moment;
      momentFormattedDeparture =
        fare && fare.departureDate && infameMomentPleaseDontImportMeNever(fare.departureDate);
      momentFormattedReturn =
        fare && fare.returnDate && infameMomentPleaseDontImportMeNever(fare.returnDate);
    } else {
      logger.warn(
        `INTEGRATION_ACTIONS: **OpenPopupAction** window.EM.___fcRuntime.vendors.moment not 
            available as global variable and the **Booking Popup** needed it`
      );
    }
  }
  const data = { ...fare };
  if (momentFormattedDeparture && momentFormattedDeparture.isValid()) {
    data.departureDate = momentFormattedDeparture;
  }
  if (momentFormattedReturn && momentFormattedReturn.isValid()) {
    data.returnDate = momentFormattedReturn;
  }

  publish('em.booking.open', data);
};
